// extracted by mini-css-extract-plugin
export default {"controls":"Controls_controls__NW6WE"};